/**
 * PROTOTYPE data-source model -- THROWAWAY.
 *
 * A source is a data provider for a volume-driven module: a mill (MT), an NDT vendor,
 * or a coating contractor. All share the same shape (name, data format, record count,
 * onboarding-NRE flag) and map onto the engine's `sources` rows; the backend reads the
 * record count off `pipeCount` for every module, so that is the field name here too.
 */

// The engine's NRE difficulty / per-record format keys (backend difficultyMultipliers).
export type SourceFormat = 'api' | 'spreadsheet' | 'scannedPdf' | 'handwritten';
export const SOURCE_FORMATS: SourceFormat[] = ['api', 'spreadsheet', 'scannedPdf', 'handwritten'];
export const SOURCE_FORMAT_LABELS: Record<SourceFormat, string> = {
  api: 'API', spreadsheet: 'Spreadsheet', scannedPdf: 'Scanned PDF', handwritten: 'Handwritten',
};

export interface ModuleSource { id: string; name: string; format: SourceFormat; pipeCount: number; chargeNre: boolean; }

/** A new source for `noun` ("Mill" / "Vendor" / "Contractor"): spreadsheet format,
 *  onboarding charged, the given record count. */
export function newSource(noun: string, index: number, pipeCount: number): ModuleSource {
  return { id: `${noun.toLowerCase()}-${index}`, name: `${noun} ${index}`, format: 'spreadsheet', pipeCount, chargeNre: true };
}

/** Total records across a module's sources (pipes / inspections / joints). */
export function sourceCount(sources: ModuleSource[]): number {
  return sources.reduce((sum, s) => sum + Math.max(0, s.pipeCount), 0);
}
